export default {
      id: "filter-usage",
      viewBox: "0 0 18 12",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#filter",
      toString: function () {
        return this.url;
      }
    }